import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbNavModule, NgbPaginationModule, NgbTypeaheadModule, NgbHighlight, NgbDropdown, NgbAccordion, NgbPanel } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { SetupRoutingModule } from './setup-routing.module';
// import { DataTablesModule } from 'angular-datatables';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '../shared/shared.module';

// companies
import { ListCompanyComponent } from 'src/app/components/setup/companies/list/list.component';
import { AddCompanyComponent } from 'src/app/components/setup/companies/add/add.component';
import { EditCompanyComponent } from 'src/app/components/setup/companies/edit/edit.component';
import { TermsConditionsComponent } from 'src/app/components/shared/terms-conditions/terms-conditions.component';
// customers
import { ListCustomerComponent } from 'src/app/components/setup/customers/list/listcustomer.component';
import { AddCustomerComponent } from 'src/app/components/setup/customers/add/addcustomer.component';
import { EditCustomerComponent } from 'src/app/components/setup/customers/edit/editcustomer.component';
// products
import { ListProductComponent } from 'src/app/components/setup/products/list/list.component';
import { AddProductComponent } from 'src/app/components/setup/products/add/add.component';
import { EditProductComponent } from 'src/app/components/setup/products/edit/edit.component';

// services
import { CompanyService } from 'src/app/services/company.service';
import { CustomerService } from 'src/app/services/customer.service';
import { ProductService } from 'src/app/services/products.service';
import { BankService } from 'src/app/services/bank.service';
// import { AddressBookService } from 'src/app/services/general/addressbook.service';
import { RateBandsService } from 'src/app/services/ratebands.service';

import { ListZonesComponent } from 'src/app/components/setup/zones/list/listzones.component';
import { ZoneLinkComponent } from '../../components/setup/zones/link/zone.component';
import { ZoneperiodComponent } from '../../components/setup/zones/link/period/zoneperiod.component';
import { ZoneDetailComponent } from '../../components/setup/zones/link/detail/zonedetails.component';

import { ZoneService } from 'src/app/services/zone.service';
import { VendorActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/vendor-action-items.component';
import { VendorService } from 'src/app/services/vendor.service';
import { EditDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/edit-delete.component';
import { FinancialYearComponent } from 'src/app/components/setup/companies/financial-year/financial-year.component';
import { UserManagementService } from 'src/app/services/user-management.service';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { NotificationsService } from 'src/app/services/notifications.service';
import { CustomerEventTableComponent } from 'src/app/components/setup/customers/event-table';
import { NotificationEventConfigComponent } from 'src/app/components/setup/customers/event-config/event-config.component';
import { AssetsComponent } from 'src/app/components/setup/assets/assets.component';
import { AssetsService } from 'src/app/services/assets/assets.service';
import { NetworkService } from 'src/app/services/network.service';
import { AddContractComponent } from '../../components/setup/customers/contract/addcontract.component';
import { MiscService } from 'src/app/services/misc/misc.service';
import { AddZoneComponent } from '../../components/setup/zones/add/add.component';
import {
  VolumetricDetailComponent
} from '../../components/setup/customers/edit/customervolumetric/volumetricdetails.component';
import { TemplateService } from 'src/app/services/system-config/template/templates.service';

@NgModule({
  declarations: [
    ListCompanyComponent,
    AddCompanyComponent,
    EditCompanyComponent,
    TermsConditionsComponent,
    FinancialYearComponent,

    ListCustomerComponent,
    AddCustomerComponent,
    EditCustomerComponent,
    AddContractComponent,

    ListProductComponent,
    AddProductComponent,
    EditProductComponent,

    ListZonesComponent,
    ZoneLinkComponent,
    ZoneDetailComponent,
    ZoneperiodComponent,
    AddZoneComponent,

    VendorActionsRenderer,
    EditDeleteActionsRenderer,
    CustomerEventTableComponent,
    NotificationEventConfigComponent,
    AssetsComponent,
    VolumetricDetailComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxUiLoaderModule,
    NgbHighlight,
    NgbNavModule,
    NgbDropdownModule,
    NgbTypeaheadModule,
    NgSelectModule,
    // DataTablesModule,
    NgbPaginationModule,
    CKEditorModule,
    AgGridModule,
    SetupRoutingModule,
    NgbAccordion,
    NgbPanel


  ],
  exports: [
    ListCompanyComponent,
    AddCompanyComponent,
    EditCompanyComponent,
    TermsConditionsComponent,
    FinancialYearComponent,

    ListCustomerComponent,
    AddCustomerComponent,
    EditCustomerComponent,

    ListProductComponent,
    AddProductComponent,
    EditProductComponent,
    AddContractComponent,

    ListZonesComponent,
    ZoneLinkComponent,
    ZoneDetailComponent,
    ZoneperiodComponent,
    VendorActionsRenderer,
    EditDeleteActionsRenderer,
    CustomerEventTableComponent,
    NotificationEventConfigComponent,
    AssetsComponent,
    AddZoneComponent,
    VolumetricDetailComponent,

  ],
  providers: [
    CompanyService,
    CustomerService,
    ProductService,
    VendorService,
    BankService,
    ZoneService,
    RateBandsService,
    UserManagementService,
    NotificationsService,
    NgbDropdown,
    AssetsService,
    NetworkService,
    MiscService,
    TemplateService
  ]
})
export class SetupModule { }
